"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractParam = exports.isSuccess = void 0;
const mocks_1 = require("./mocks");
class MagaluService {
    static request({ serviceName, serviceArgs, callbackId, callback }, mockMode) {
        var _a, _b, _c, _d;
        if (callbackId && callback) {
            this.callbacks.set(callbackId, callback);
        }
        if (mockMode) {
            let response;
            let bodyResponde;
            switch (serviceName) {
                case 'customer.getCustomerInfo':
                    bodyResponde = mocks_1.customerInfo;
                    break;
                case 'customer.getCustomerAddress':
                    bodyResponde = mocks_1.adresses;
                    break;
                case 'customer.getCustomerLocation':
                    bodyResponde = mocks_1.zipCode;
                    break;
            }
            response = {
                callbackId: callbackId || '',
                code: 200,
                body: bodyResponde,
            };
            return this.pushResponse(response);
        }
        try {
            const argsString = JSON.stringify(serviceArgs);
            const payload = {
                callbackId,
                serviceName,
                authId: (_a = this.hash) !== null && _a !== void 0 ? _a : '',
                arguments: argsString,
            };
            const message = JSON.stringify(payload);
            if ((_c = (_b = window === null || window === void 0 ? void 0 : window.webkit) === null || _b === void 0 ? void 0 : _b.messageHandlers) === null || _c === void 0 ? void 0 : _c.magaluSdk) {
                window.webkit.messageHandlers.magaluSdk.postMessage(message);
            }
            else if ((_d = window === null || window === void 0 ? void 0 : window.magaluSdk) === null || _d === void 0 ? void 0 : _d.requestService) {
                window.magaluSdk.requestService(message);
            }
            else {
                console.warn("didn't found any sdk");
                callbackId && this.callbacks.delete(callbackId);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    static unregister(callbackId) {
        this.callbacks.delete(callbackId);
    }
    static unregisterAll() {
        this.callbacks.clear();
    }
    static pushResponse(response) {
        try {
            const callback = this.callbacks.get(response.callbackId);
            if (!callback) {
                return;
            }
            return callback(response);
        }
        catch (e) {
            console.error(e);
        }
    }
    static requestCredentials() {
        var _a;
        if ((_a = this.jwt) === null || _a === void 0 ? void 0 : _a.length) {
            return this.jwt;
        }
        else {
            this.request({
                serviceName: 'customer.requestCredentials',
                callbackId: 'requestCredentials',
                callback: (result) => {
                    if (isSuccess(result)) {
                        if (typeof window !== 'undefined') {
                            document.cookie = `jwt=${result.body.jwt}`;
                            sessionStorage.setItem('jwt', result.body.jwt);
                        }
                        this.jwt = result.body.jwt;
                    }
                    return result;
                },
            });
        }
    }
    static registerNavbarActionsCallback(callback) {
        if (callback) {
            this.callbacks.set('appbar.actionPressed', callback);
        }
    }
}
MagaluService.jwt = extractParam('jwt');
MagaluService.hash = extractParam('hash');
MagaluService.deeplink = extractParam('deeplink');
MagaluService.callbacks = new Map();
function isSuccess(result) {
    return result.code >= 200 && result.code < 300;
}
exports.isSuccess = isSuccess;
function extractParam(value) {
    if (typeof window === 'undefined') {
        return null;
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let param = urlParams.get(value);
    if (param === null || param === void 0 ? void 0 : param.length) {
        sessionStorage.setItem(value, param);
    }
    else {
        param = sessionStorage.getItem(value);
    }
    return param;
}
exports.extractParam = extractParam;
if (typeof window !== 'undefined') {
    window.MagaluService = MagaluService;
}
exports.default = MagaluService;
